import * as React from "react";
import { Message } from "../../types";
import FluidFrame from "../FluidFrame";
import DefaultHead from "../DefaultHead";
import MessagePreviewList from "./MessagePreviewList";

interface MessagePreviewBoxProps {
  messages: Array<Message>;
  onExpand: () => void;
  onClose: () => void;
}

class MessagePreviewBox extends React.Component<MessagePreviewBoxProps, {}> {
  public render() {
    if (this.props.messages.length === 0) {
      return null;
    }

    return (
      <div className="velaro-message-preview-frame">
        <FluidFrame head={<DefaultHead />}>
          <MessagePreviewList
            messages={this.props.messages}
            onClose={this.props.onClose}
            onExpand={this.props.onExpand}
          />
        </FluidFrame>
      </div>
    );
  }
}

export default MessagePreviewBox;
